import styled from "styled-components";

export const StyledSection = styled.section<{
  rightAligned?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  margin-right: 80px;
  flex-direction: ${({ rightAligned }): string =>
    rightAligned ? "row-reverse" : "row"};
`;
